import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase environment variables not set. Using placeholder values for development.')
}

export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-anon-key',
  { db: { schema: 'cloudmind' } }
)

// Auth helper: set Clerk JWT as Supabase auth token
// When Clerk is disabled (mock-auth), falls back to the base Supabase client
export async function getSupabaseWithClerkAuth(
  getToken: (options?: { template?: string }) => Promise<string | null>
) {
  const token = await getToken({ template: 'supabase' })
  if (!token) {
    // No auth token (Clerk disabled) — return base client
    return supabase
  }
  return createClient(
    supabaseUrl || 'https://placeholder.supabase.co',
    supabaseAnonKey || 'placeholder-anon-key',
    {
      global: {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    }
  )
}

// Database types
export interface WaitlistEntry {
  id?: string
  email: string
  country: string
  use_case: string
  created_at?: string
}

export interface Customer {
  id: string
  clerk_user_id: string
  email: string
  name?: string
  company?: string
  country_code: string
  currency_preference: string
  region_preference: string
  plan: string
  credit_balance_usd: number
  created_at: string
  updated_at: string
}

export interface APIKey {
  id: string
  customer_id: string
  name: string
  key_prefix: string
  status: 'active' | 'revoked'
  rate_limit_rpm: number
  last_used_at?: string
  created_at: string
}

export interface UsageEvent {
  id: string
  customer_id: string
  model: string
  tier: string
  tokens_in: number
  tokens_out: number
  total_tokens: number
  cost_usd: number
  latency_ms?: number
  region?: string
  requested_at?: string
  created_at: string
}

export interface DailyUsage {
  day: string
  total_tokens: number
  total_cost_usd: number
  request_count: number
}

export interface TierUsage {
  tier: string
  total_tokens: number
  total_cost_usd: number
}

export interface Transaction {
  id: string
  customer_id: string
  type: 'topup' | 'usage' | 'refund'
  amount_usd: number
  description: string
  created_at: string
}
